import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { useFormik } from "formik";
import { CircularProgress, Button } from "@material-ui/core";
import { KTUtil } from "./../../../../_metronic/_assets/js/components/util.js";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { API_URL } from "../../../../constants";
import { onAxiosApiCall, getLanguage } from "../../../../utils";
import styles from "./resetpassword.module.scss";

const initialValues = {
  token: "",
  newpassword: "",
  password: "",
};

function ResetPassword(props) {
  var language = getLanguage(navigator.language);
  // client panel content
  const [clientPanelContent, setClientPanelContent] = useState("");
  const [fromPwaApp, setFromPwaApp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [token, SetToken] = useState("");
  const bgImage = toAbsoluteUrl("/media/bg/bg-3.jpg");
  const history = useHistory();

  const LoginSchema = Yup.object().shape({
    newpassword: Yup.string()
      .min(3, clientPanelContent.min_three_txt_error)
      .max(50, clientPanelContent.max_no_txt_error)
      .required(clientPanelContent.password_required_txt),
    password: Yup.string()
      .min(3, clientPanelContent.min_three_txt_error)
      .max(50, clientPanelContent.max_no_txt_error)
      .required(clientPanelContent.password_required_txt)
      .oneOf([Yup.ref("newpassword"), null], clientPanelContent.password_match_txt),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };
  useEffect(() => {
    let location = props.location.pathname;
    let getrestoken = location.split("/");
    CheckUser(props, getrestoken[2]);
    SetToken(getrestoken[2]);
  }, []);

  useEffect(() => {
    getClientPanelContent();
  }, []);

  // get client panel contents
  const getClientPanelContent = () => {
    const section = "resetpass_screen";
    onAxiosApiCall(API_URL + language + "/get-client-panel-content/" + section, "GET", "")
    .then((response) => {
      if (response.data !== undefined && response.data !== "") {
        setClientPanelContent(response.data[section]);
      } else {
        setClientPanelContent("");
      }
    });
  }

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setSubmitting }) => {
      values.token = token;
      console.log(values);
      setTimeout(() => {
        setLoading(true);
        setDisabled(true);
        onAxiosApiCall(API_URL + "storednew-password", "POST", values)
          .then((response) => {
            if (response.status === 200) {
              setSubmitting(false);
              setLoading(false);
              setDisabled(false);
              Swal.fire(clientPanelContent[response.success_key] !== undefined ? clientPanelContent[response.success_key] : "", "", "success");
              setTimeout(() => {
                history.push("/login");
              }, 200);
            } else {
              setLoading(false);
              setDisabled(false);
              Swal.fire(clientPanelContent[response.error_key] !== undefined ? clientPanelContent[response.error_key] : "", "", "error");
            }
          })
          .catch((error) => {
            console.log("error", error);
            setLoading(false);
            setDisabled(false);
          });
      }, 500);
    },
  });

  const CheckUser = (props, app_token) => {
    // SetToken(myArr[1]);
    console.log(app_token);
    const value = {
      token: app_token,
    };
    onAxiosApiCall(API_URL + "check_user", "POST", value).then((response) => {
      if (response.status == 400) {
        history.push("/login");
      }
    });
  };

  return (
    <>
      <div
        className={`login login-3 wizard d-flex flex-column flex-lg-row h-100 w-100 ${
          KTUtil.isMobileDevice() ? "mobile-login" : "flex-column-fluid"
        }`}
      >
        <div
          className={`login-aside flex-column flex-center flex-row-auto ${styles.loginRoot} `}
        >
          <div
            className={`d-flex justify-content-start align-items-center h-100 px-10`}
          >
             <div className={`${styles.leftsideTextDiv}`}>
              <div className="d-flex mb-10">
                <img
                  src={toAbsoluteUrl("/media/logos/white-logo.png")}
                  className={`w-230px ${styles.desktopLogo}`}
                  alt=""
                />
              </div>
              <h2
                className={`font-weight-bolder ${styles.welcomBackText}`}
                dangerouslySetInnerHTML={{
                  __html:
                    clientPanelContent !== undefined &&
                    clientPanelContent !== "" &&
                    clientPanelContent.page_title !== undefined &&
                    clientPanelContent.page_title !== ""
                      ? clientPanelContent.page_title
                      : "Welcome Back to <br />Youshow",
                }}
              ></h2>
              <div className={`${styles.separator}`}></div>
              <h4
                className={`font-weight-bolder ${styles.subtext}`}
                dangerouslySetInnerHTML={{
                  __html:
                    clientPanelContent !== undefined &&
                    clientPanelContent !== "" &&
                    clientPanelContent.sub_title !== undefined &&
                    clientPanelContent.sub_title !== ""
                      ? clientPanelContent.sub_title
                      : "Sign in to continue to your account.",
                }}
              ></h4>
            </div>
          </div>
        </div>
        <div
          className={`login-content flex-row-fluid d-flex flex-column p-10 `}
        >
          <div className="d-flex flex-row-fluid flex-center">
            <div className="login-form">
              <div className="d-flex flex-center mb-15">
                <img
                  src={toAbsoluteUrl("/media/logos/white-logo.png")}
                  className={`w-250px ${styles.mobileLogo}`}
                  alt=""
                />
              </div>
              <div className="reset-password">
                <form
                  onSubmit={formik.handleSubmit}
                  id="kt_login_signin_form"
                  className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
                >
                  {formik.status && (
                    <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                      <div className="alert-text font-weight-bold">
                        {formik.status}
                      </div>
                    </div>
                  )}
                  <div className={`form-group fv-plugins-icon-container ${styles.formControl}`}>
                    <input
                      placeholder={clientPanelContent !== undefined && clientPanelContent !== "" && clientPanelContent.newpassword_txt !== undefined && clientPanelContent.newpassword_txt !== "" ? clientPanelContent.newpassword_txt : ""}
                      type="password"
                      className={`form-control h-auto form-control-solid py-4 px-8 ${getInputClasses(
                        "newpassword"
                      )}`}
                      name="newpassword"
                      autoComplete="off"
                      {...formik.getFieldProps("newpassword")}
                    />
                    {formik.touched.newpassword && formik.errors.newpassword ? (
                      <div className="fv-plugins-message-container text-left">
                        <div className="fv-help-block">
                          {formik.errors.newpassword}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className={`form-group fv-plugins-icon-container ${styles.formControl}`}>
                    <input
                      placeholder={clientPanelContent !== undefined && clientPanelContent !== "" && clientPanelContent.confirm_password !== undefined && clientPanelContent.confirm_password !== "" ? clientPanelContent.confirm_password : ""}
                      type="password"
                      className={`form-control h-auto form-control-solid py-4 px-8 ${getInputClasses(
                        "password"
                      )}`}
                      name="password"
                      {...formik.getFieldProps("password")}
                    />
                    {formik.touched.password && formik.errors.password ? (
                      <div className="fv-plugins-message-container text-left">
                        <div className="fv-help-block">
                          {formik.errors.password}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="form-group w-100">
                    <Button
                      type="submit"
                      id="kt_login_forgot_submit"
                      className={`w-100 ${styles.submitBtn}`}
                      disabled={disabled}
                    >
                      {clientPanelContent !== undefined &&
                      clientPanelContent !== "" &&
                      clientPanelContent.save_btn_txt !== undefined &&
                      clientPanelContent.save_btn_txt !== ""
                        ? clientPanelContent.save_btn_txt
                        : ""}
                      {loading && (
                        <CircularProgress
                          size="1.5rem"
                          color="#fff"
                          className="ml-2"
                        />
                      )}
                    </Button>
                      {fromPwaApp && (
                        <div className={`form-group d-flex flex-wrap flex-center ${styles.backtoLogin}`}>
                          <a
                            href="#"
                            className="go-to-app"
                            //onClick={gotToPwaApp}
                          >
                            <svg
                              width="10"
                              height="12"
                              viewBox="0 0 6 8"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.28027 0.94L2.22027 4L5.28027 7.06L4.33361 8L0.333607 4L4.33361 -4.13801e-08L5.28027 0.94Z"
                                fill="#FF6D3F"
                              />
                            </svg>{" "}
                            {clientPanelContent !== undefined && clientPanelContent !== "" && clientPanelContent.go_to_app_btn_text !== undefined && clientPanelContent.go_to_app_btn_text !== "" ? clientPanelContent.go_to_app_btn_text : ""}
                          </a>
                        </div>
                      )}
                  </div>
                </form>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
